module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./~/_axios@0.17.1@axios/index.js
// module id = 2sCs
// module chunks = 0